import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[toastHost]',
})
export class ToasthostDirective {
    constructor(public viewContainerRef: ViewContainerRef) {}
}
